import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/site";
import { SectionHeading } from "@/components/landing/Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="scroll-mt-32 lg:scroll-mt-40 lg:flex lg:min-h-screen lg:items-start pb-10 pt-6 sm:pb-14 sm:pt-8 lg:py-12">
    <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="FAQ"
        title="Questions about the company"
        description="What Moruya Travel Solutions is, what it does not do, and how to reach the right person."
        align="center"
      />

      <div className="mx-auto mt-10 max-w-3xl">
        <Accordion
          type="single"
          collapsible
          data-testid="faq-accordion"
          className="space-y-3"
        >
          {FAQS.map((item, index) => (
            <AccordionItem
              key={item.q}
              value={`faq-${index}`}
              data-testid={`faq-item-${index}`}
              className="rounded-[14px] border border-slate-200 bg-white px-4 shadow-[var(--shadow-sm)]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${index}`}
                className="text-left text-sm font-semibold text-[#0b1d3a] hover:no-underline sm:text-base"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-slate-600">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
